module.exports = "<ul ng-attr-id=\"{{ type + 'scroll' }}\">\r\n    <li ng-repeat=\"item in list\" ng-class=\"{['checkedEditPost'+ type]: itemChecked.item[item._id]}\"> \r\n        <div class=\"checkbox checkbox-primary\">\r\n            <input type=\"checkbox\" ng-model=\"itemChecked.item[item._id]\" ng-click = \"updateSelection(item._id, itemChecked.item[item._id], item)\" id=\"{{item._id}}\">\r\n            <label for=\"{{item._id}}\">{{item.name}}</label>\r\n        </div>\r\n    </li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/checkedListItem/partial/checkedListItem.html
// module id = 241
// module chunks = 0